import script from "./ViewControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewControls.vue?vue&type=script&setup=true&lang=ts"

import "./ViewControls.vue?vue&type=style&index=0&id=0b9443aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9443aa"]])

export default __exports__